import styled from 'styled-components';
import {
    ModalDialog,
} from '@zillow/constellation';

export const StyledModalDialog = styled(ModalDialog)`
    &.ModalDialog--disabled {
        [class^="DialogClose"] {
            display: none;
        }
    }
`;
